var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      attrs: {
        id: "search",
        "grid-list-xl": "",
        "text-center": "",
        role: "search",
        "aria-label": "Search Section",
      },
    },
    [
      _c(
        "v-layout",
        { attrs: { wrap: "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "", sm12: "", md12: "", lg12: "" } },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-container",
                    { attrs: { fluid: "", "grid-list-md": "" } },
                    [
                      _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            [
                              _c("v-text-field", {
                                attrs: {
                                  "append-icon": "fal fa-search",
                                  color: "accent",
                                  "v-validate":
                                    "required|min:1|max:" + _vm.limit,
                                  "data-vv-as":
                                    _vm.subject.toLowerCase() + " search",
                                  "data-vv-name": "search",
                                  "error-messages":
                                    _vm.errors.collect("search"),
                                  label:
                                    _vm.$t(
                                      "components." +
                                        _vm.subject
                                          .toLowerCase()
                                          .replace(" ", "_") +
                                        ".search"
                                    ) + " *",
                                  name: "search",
                                  type: "search",
                                  "aria-label": "Search",
                                  "aria-required": "true",
                                  "aria-invalid": _vm.errors.has("search"),
                                  autocomplete: "off",
                                },
                                model: {
                                  value: _vm.search,
                                  callback: function ($$v) {
                                    _vm.search = $$v
                                  },
                                  expression: "search",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }